import { ActivableModel } from '@app/core/models/shared/activable.model';
import { GroupModel } from '../groups/group.model';

export class WorkflowStage extends ActivableModel {

  constructor(level: number) {
    super();
    this.Level = level;
    this.ValidationGroup = new GroupModel();
    this.IsOptional = false;
  }

  public Id: number;

  public ValidationGroup: GroupModel;

  public Level: number;

  public ThresholdAmount: number;

  public IsOptional: boolean;

}
